module.exports = __webpack_public_path__ + "static/img/product_img_06.3b14837.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_img_06.jpg
// module id = tLIt
// module chunks = 0